import actionTypes from './actionTypes'

const accessibilityActions = {
	fetchAccessibilityData: (id: string, altText: string, isDecorative: boolean) => ({
		type: actionTypes.ACCESSIBILITY_DATA_FETCHED,
		id,
		altText,
		isDecorative,
	}),
}

export default accessibilityActions
